import { Button } from "../../../../core/components/atoms/Button";
import { Typography } from "../../../../core/components/molecules/Typography";
import { Modal } from "../../../../core/components/templates/Modal";

interface IModalOnSuccess {
  action: () => void;
  isOpen: boolean;
  onClose: () => void;
}

export default function ModalOnUnload({ action, isOpen, onClose }: IModalOnSuccess) {
  
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose()}
      position="center"
      className="p-0 w-2/5"
    >
      <div className="flex flex-col gap-xl">
        <Typography>
          Sua redação ainda não foi enviada apara correção. Ela ficará salva se você sair dessa página sem envia-la;
        </Typography>
        <div className="flex flex-row items-center justify-end gap-sm">
          <Button variant="text" onClick={() => action()}>
            Ok
          </Button>
        </div>
      </div>
    </Modal>
  )
}